import React, { useEffect, useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import galleryImages from "./galleryImage";

const MasonryImagesGallery = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    updateIsMobile(); // Initial check
    window.addEventListener("resize", updateIsMobile);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true, // Adjusts height based on the content
    autoplay: true, // Enable automatic scrolling
    autoplaySpeed: 2000,
  };

  return (
    <>
      {isMobile ? (
        <Slider {...settings}>
          {galleryImages.map((item, index) => (
            <div key={index} className="masonry__img">
              <img
                src={item}
                alt=""
                style={{
                  width: "100%",
                  display: "block",
                  borderRadius: "10px",
                }}
              />
            </div>
          ))}
        </Slider>
      ) : (
        <ResponsiveMasonry columnsCountBreakpoints={{ 350: 1, 768: 3, 992: 4 }}>
          <Masonry gutter="1rem">
            {galleryImages.map((item, index) => (
              <img
                className="masonry__img"
                src={item}
                key={index}
                alt=""
                style={{
                  width: "100%",
                  display: "block",
                  borderRadius: "10px",
                }}
              />
            ))}
          </Masonry>
        </ResponsiveMasonry>
      )}
    </>
  );
};

export default MasonryImagesGallery;
